import React from "react";
import './Paginations.css';  // Import the CSS file

const Paginations = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  return (
    <div>
      <nav aria-label="Page navigation example">
        <ul className="pagination">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a
              className="page-link"
              aria-label="Previous"
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <span aria-hidden="true">&laquo;</span>
              {/*<span className="sr-only">Previous</span>*/}
            </a>
          </li>
          {pageNumbers.map((number) => (
            <li
              className={`page-item ${currentPage === number ? "active" : ""}`}
              key={number}
            >
              <a className="page-link" onClick={() => onPageChange(number)}>
                {number}
              </a>
            </li>
          ))}
          <li
            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
          >
            <a
              className="page-link"
              aria-label="Next"
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <span aria-hidden="true">&raquo;</span>
              {/*<span className="sr-only">Next</span>*/}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Paginations;
